import React, { Component } from 'react'
import { Col, Label, Row, Button } from 'reactstrap'
import Card from '../../comum/components/Card';
import { inject, observer } from 'mobx-react';
import _ from "lodash"
import moment from "moment"
import TabelasAcomp from './TabelasAcomp';
import { IconeSetaDescer, IconeSetaSubir } from '../../comum/components/Icones';

@inject("store")
@observer
export default class ConsultaArquivosProcessos extends Component {
    constructor(props){
        super(props)

        this.controller = this.props.controller

        this.colunas = [{
            name: "Id",
            param: "DescStatus"
        },{
            name: "Usuário",
            param: "DocumentoDespacho"
        },{
            name: "Data",
            param: "Despachante"
        },{
            name: "Documento",
            param: "Transportadora"
        },{
            name: "Observação",
            param: "DataSiscomex"
        }
    ]
    }

    render() {
        return (
            <div className="card-expansivel card-expansivel-tabela tabela-acomp-processo">
            <div className="card">
                <Row className={`titulo-booking align-items-center ${this.controller.arquivosExpandido && 'login-form'}`}>
                    <Col>
                        <div className="card-expansivel--titulo">Arquivos do processo</div>
                    </Col>
                    <Col>
                        <div className="float-right">
                            <Button onClick={ () => this.controller.abrirFecharDetalhe("arquivos") } outline className="collapseItem" active={ false }>
                                { this.controller.arquivosExpandido ? <IconeSetaSubir tamanho="lg" /> : <IconeSetaDescer tamanho="lg" /> }
                            </Button>
                        </div>
                    </Col>
                </Row>
                { this.controller.arquivosExpandido  &&
                    <React.Fragment>
                        <TabelasAcomp
                            keyField="ContainerId" 
                            colunas = {this.controller.colunasArquivos}
                            dados = {this.controller.dadosContainers}
                            controller={this.controller}
                            avaria = {true}
                        />
                    </React.Fragment>
                }
            </div>
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/ConsultaArquivosProcesso.js